<template>
  <div class="activity-product-list-wrapper">

    <div class="activity-product-list" v-if="list && list.length">
      <div 
        class="product-item" 
        v-for="(product, productIndex) in list" 
        :key="productIndex"
        v-observe-visibility="(isVisible, entry) => onVisibilityChanged(isVisible, entry, product, productIndex)">
        <activity-product-item :product="product" @clickProduct="(event) => gotoProductPage(event, product, productIndex)">
        </activity-product-item>
      </div>
    </div>

    <div class="no-data" v-else>
      <img src="../../../../../assets/imgs/index/index-activity/no-product.png">
      <div class="no-data-msg">您所在的地区暂时没有促销活动，敬请期待～</div>
    </div>

  </div>
</template>


<script>
import sensorsdata from 'sa-sdk-javascript';
import sensorService from '@/services/sensor-service';
import ActivityProductItem from '@/components/activity/index-activity/activity-product-item.vue';

export default {
  components: {
    ActivityProductItem,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    activityInfo: {
      type: Object,
      default: () => {},
    },
    activityIndex: {
      type: Number,
      default: 0,
    },
    provinceCode: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    onVisibilityChanged(isVisible, entry, item, index) {
      if (isVisible) {
        sensorsdata.track('ProductResourceExpose', {
          floor_position: this.activityIndex + 1,
          page_from: '首页',
          product_type: '签证商品',
          activity_name: this.activityInfo.activity_name,
          product_position: +index + 1,
          product_name: item.product_name,
          visa_product_id: item.visa_product_id,
        });
      }
    },
    gotoProductPage(e, productInfo, productIndex) {
      sensorsdata.quick('trackHeatMap', e.target);
      sensorsdata.track('SalesPromotionClick', {
        product_id: productInfo.visa_product_id,
        product_name: productInfo.product_name,
        click_source: 'index',
      });
      sensorsdata.track('ProductResourceClick', {
        floor_position: this.activityIndex + 1,
        page_from: '首页',
        product_type: '签证商品',
        activity_name: this.activityInfo.activity_name,
        product_position: +productIndex + 1,
        product_name: productInfo.product_name,
        visa_product_id: productInfo.visa_product_id,
      });
      // 商详神策埋点page_from字段
      const pageFrom = sensorService.getPageFrom('首页-电子签专区');
      this.$router.push({ name: 'product', params: { visa_product_id: productInfo.visa_product_id }, query: { province_code: this.provinceCode, ...pageFrom } });
    },

  },
};
</script>


<style lang="less" scoped>
.activity-product-list-wrapper {
  width: 100%;
}
.activity-product-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 21px;
  margin-bottom: -20px;
  .product-item {
    width: 360px;
    margin: 0 0 20px 20px;
    &:nth-child(3n+1){
      margin: 0 0 20px 0;
    }
  }
}
.no-data {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 32px 0 34px 0;
  img {
    width: 200px;
    height: 200px;
  }
  .no-data-msg {
    font-size: 16px;
    color: #91999F;
    line-height: 22px;
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/index-activity/components/activity-product-list.vue